export const LINKS = {
  shopee: "https://shopee.com.br/bragtech_informatica",
  instagram: "https://www.instagram.com/_animeglam",
  whatsapp:
    "https://wa.me/5511959759597?text=Oi!%20Vim%20pelo%20site%20da%20Anime%20Glam%20e%20quero%20conhecer%20os%20mimos%20kawaii%20%E2%9C%A8",
  whatsapp2: "https://wa.me/5511995214274",
  maps: "https://maps.google.com/?q=R.+Cel.+Os%C3%B3rio,+162+-+Centro,+Bragan%C3%A7a+Paulista+-+SP,+12900-150",
};

export const scrollToId = (id) => (e) => {
  e.preventDefault();
  if (window.__lenis) window.__lenis.scrollTo(id, { offset: -76 });
  else document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
};

export const PRODUCTS = [
  {
    id: "quadros",
    title: "Quadros Decorativos",
    badge: "Decoração",
    img: "images/produtos/quadros.jpg",
    span: "sm:col-span-2 lg:col-span-3",
    featured: true,
    desc: "Impressões em alta qualidade dos seus personagens e animes favoritos para transformar seu quarto, seu setup ou seu cantinho de estudos em um verdadeiro shrine geek.",
  },
  {
    id: "canecas",
    title: "Canecas Personalizadas",
    badge: "Para Presente",
    img: "images/produtos/canecas.jpg",
    images: [
      "images/produtos/canecas.jpg",
      "images/produtos/caneca-frieren.jpg",
      "images/produtos/caneca-growlithe.jpg",
      "images/produtos/caneca-jojo.jpg",
    ],
    span: "sm:col-span-2 lg:col-span-3",
    featured: true,
    desc: "Canecas de cerâmica com estampas exclusivas de animes, mangás e personagens fofos. O café da manhã merece começar com esse poder.",
  },
  {
    id: "brincos",
    title: "Brincos Geek",
    badge: "Lançamento",
    img: "images/produtos/brincos.jpg",
    span: "lg:col-span-2",
    desc: "Brincos leves e encantadores com seus personagens favoritos, prontos para dar o toque final ao seu look.",
  },
  {
    id: "pingentes",
    title: "Pingentes de Celular",
    badge: "Tendência",
    img: "images/produtos/pingentes.jpg",
    span: "lg:col-span-2",
    desc: "Phone charms fofos com cordão para deixar o seu smartphone único — estilo, charme e proteção juntos.",
  },
  {
    id: "pulseiras",
    title: "Pulseiras Kawaii",
    badge: "Feito à Mão",
    img: "images/produtos/pulseiras.jpg",
    span: "lg:col-span-2",
    desc: "Pulseiras artesanais com miçangas, contas e charms para combinar com qualquer estilo, do soft ao rockeiro.",
  },
  {
    id: "agendas",
    title: "Agendas & Planners",
    badge: "Mais Vendidos",
    img: "images/produtos/agendas.jpg",
    images: [
      "images/produtos/agendas.jpg",
      "images/produtos/agenda-bts.jpg",
      "images/produtos/agenda-skz.jpg",
      "images/produtos/agenda-aberta.jpg",
      "images/produtos/agenda-miku.jpg",
    ],
    span: "lg:col-span-2",
    desc: "Agendas e planners ilustrados dos seus idols e animes favoritos para organizar o ano com muita fofura.",
  },
  {
    id: "colares",
    title: "Colares & Correntes",
    badge: "Coleção Anime",
    img: "images/produtos/colares.jpg",
    span: "lg:col-span-2",
    desc: "Colares delicados com pingentes temáticos para carregar o seu anime favorito sempre pertinho do coração.",
  },
  {
    id: "marcapaginas",
    title: "Marca Páginas",
    badge: "Favorito Geek",
    img: "images/produtos/marcapaginas.jpg",
    span: "lg:col-span-2",
    desc: "Marca páginas encantadores para acompanhar as suas leituras de mangá, capítulo por capítulo, com estilo.",
  },
];

export const CONTACT = {
  address: "R. Cel. Osório, 162 - Centro, Bragança Paulista - SP, 12900-150",
  email: "contato@animeglam.com.br",
  hours: [
    ["Seg – Sex", "9:00 às 18:00"],
    ["Sábado", "9:00 às 14:00"],
  ],
  phones: [
    ["(11) 95975-9597", "tel:+5511959759597"],
    ["(11) 99521-4274", "tel:+5511995214274"],
  ],
};
